import axios from 'axios'
import { dashboardAPIUrl } from '@/envConfig'

export default axios.create({
    baseURL: dashboardAPIUrl + 'api/',
    headers: {
        "X-Requested-With": "XMLHttpRequest",
        'Authorization': `VueDashboardToken ${localStorage.getItem('apiToken')}`
    }
})